import React from 'react';
import ReactDOM from 'react-dom';
import queryString from 'query-string';

import App from './App';
import GlobalStyles from './GlobalStyles';
import useLanguages from './hooks/useLanguages';

const MainAppWrapper = () => {
  const queryParams = queryString.parse(window.location.search);
  const { lang: defaultLanguage } = queryParams;

  const languages = useLanguages(defaultLanguage);

  return (
    <>
      <GlobalStyles />
      <App languages={languages} queryParams={queryParams} />
    </>
  );
};

ReactDOM.render(<MainAppWrapper />, document.getElementById('root'));
